var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHackTheHillLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137 84",
    style: {
      enableBackground: "new 0 0 137 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BFCFF6;}\n\t.st1{fill:#5C71AD;}\n\t.st2{fill:#3B4779;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#5C71AD;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.5,5.5h-0.2v3h0.2V5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.6,44.3H79.3V75h12.3V44.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.6,30.5H79.3v12.3h12.3V30.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77,42.8h16.9l-0.9,1.5h-15L77,42.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.8,32.4c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3C78.5,32.2,78.6,32.4,78.8,32.4 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.1,32.4c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3C91.8,32.2,91.9,32.4,92.1,32.4 z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.4,8.5l6.2,22H79.3L85.4,8.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.1,7.7h-1.3v3h1.3V7.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.9,35.2h-1.7v7.6h1.7V35.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.7,35.2h-1.7v7.6h1.7V35.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.9,52.3c0.2,0,0.4-1.4,0.4-3.2s-0.2-3.2-0.4-3.2c-0.2,0-0.4,1.4-0.4,3.2S81.7,52.3,81.9,52.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.2,52.3c0.2,0,0.4-1.4,0.4-3.2s-0.2-3.2-0.4-3.2c-0.2,0-0.4,1.4-0.4,3.2S84,52.3,84.2,52.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.7,52.3c0.2,0,0.4-1.4,0.4-3.2s-0.2-3.2-0.4-3.2c-0.2,0-0.4,1.4-0.4,3.2S88.5,52.3,88.7,52.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.5,52.3c0.2,0,0.4-1.4,0.4-3.2s-0.2-3.2-0.4-3.2s-0.4,1.4-0.4,3.2S86.3,52.3,86.5,52.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.3,3h-4v2.5h4V3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.8,31.8l-0.9,3.6h1.8L78.8,31.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.1,31.8l-0.9,3.6H93L92.1,31.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.5,41.8c2.8,0,5.1-2.3,5.1-5.1c0-2.8-2.3-5.1-5.1-5.1s-5.1,2.3-5.1,5.1C80.4,39.6,82.7,41.8,85.5,41.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.5,41.1c2.4,0,4.4-2,4.4-4.4s-2-4.4-4.4-4.4s-4.4,2-4.4,4.4S83.1,41.1,85.5,41.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.4,37.3c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5S85,36.6,85,36.8S85.2,37.3,85.4,37.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.4,36.8l-2,1.4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.4,36.8l2.4,2.1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.3,75V41.6c0-9.4-6.7-15.1-16.4-15.1c-6.3,0-12.1,3.2-13.9,7.4V10.5H30.5V75h12.5V47.9 c0-6.3,3.5-11.5,9.7-11.5c5.7,0,8.1,2.2,8.1,9.3V75H73.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110,75V10.5H97.5V75H110z M127.7,75V10.5h-12.5V75H127.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.6,60.2H16.5c-2.9,0-4.6,2.3-4.6,5.7c0,2.2,1,4.2,2.2,4.8H7V75h19.6v-4.3h-8.2c-1.9,0-3.5-1.2-3.5-3.4 c0-2,0.7-2.8,2.8-2.8h8.9V60.2z M21.2,48.3c1.7,0,3.1,1.7,3.1,3.9c0,1.4-0.5,2.1-1.6,2.1c-1.2,0-1.8-0.8-2.2-3.3 c-0.3-1.6-0.5-2.4-0.8-2.8L21.2,48.3z M26.6,44h-9.1c-3.6,0-5.7,1.8-5.7,7c0,5.3,2.1,7.1,5.1,7.2v-4c-1.3-0.2-2.1-1-2.1-3 c0-1.7,0.6-2.8,1.5-2.8c1,0,1.4,0.6,1.6,2.8c0.5,4.4,1,7.5,5.1,7.5c2.3,0,3.9-1.7,3.9-5.5c0-2.2-0.7-3.9-1.7-5 c0.4,0,0.9-0.1,1.3-0.3V44z M21.4,31.7c1.5,0.2,2.4,1.5,2.4,3.2c0,1.7-1.5,3.2-4.6,3.2S15,36.6,15,34.7c0-1.6,0.9-2.9,2.4-3.1v-4.4 c-3.4,0.3-5.5,3.2-5.5,7.4c0,4.6,2.2,7.7,7.4,7.7s7.7-3.1,7.7-7.5c0-4-2.2-7.1-5.6-7.5V31.7z M26.6,11.1l-9.1,5.4L12.3,11v5.3 l5.5,5.4H7V26h19.6v-4.4h-4.6l-1.9-2.1l6.5-3.6V11.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.9,17.3c0,0.8-0.3,1.3-1.1,1.3c-0.7,0-1.1-0.5-1.1-1.3v-2.7h3.8v-1.2h-3.8v-1.7H47v5.8 c0,1.4,0.8,2.6,2.8,2.6c2,0,2.8-1.2,2.8-2.6v-1.8h-1.7V17.3z M59.7,19.8v-4.6c0-1.3-1-2.1-2.4-2.1c-0.9,0-1.8,0.4-2.1,1V11h-1.8v8.8 h1.8v-3.7c0-0.9,0.5-1.6,1.4-1.6c0.8,0,1.2,0.3,1.2,1.3v4H59.7z M62.3,16c0.1-0.9,0.7-1.4,1.4-1.4c0.7,0,1.4,0.5,1.4,1.4H62.3z  M67,17c0-2.6-1.1-3.8-3.3-3.8s-3.4,1.3-3.4,3.3c0,2.3,1.2,3.5,3.5,3.5c1.5,0,2.6-0.7,3.1-2.1H65c-0.1,0.4-0.7,0.7-1.2,0.7 c-0.9,0-1.5-0.6-1.6-1.6H67z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackTheHillLogo);
export default __webpack_public_path__ + "static/media/HackTheHillLogo.35b8d7f274142f9622212f122b3c419b.svg";
export { ForwardRef as ReactComponent };